import React from 'react';
import Navbar from './Navbar';
import MobileNavbar from './MobileNavbar';
import OurServicesSection from './OurServicesSection';
import ProjectsSection from './ProjectsSection';
import WhatWeDoSection from './WhatWeDoSection';
import PartnerSection from './PartnerSection';
import Footer from './Footer';
import logo from '../assets/img/logo.svg';
import styles from '../styles/pages/home.module.css';
import globalStyles from '../styles/global.module.css';

const Home = () => {
  return (
    <>
      <section className={styles.mainHero}>
        <Navbar />
        <div className={styles.heroContent}>
          <div className={styles.logoContainer}>
            <img className={styles.logo} src={logo} alt="Hi-Tech Business Hub" />
          </div>
          
          <MobileNavbar />
          
          <div className={styles.homeContainer}>
            <h1 className={styles.heroTitle}>
              We are Hi-Tech Business hub in Georgia and international business, including in other countries
            </h1>
            <p className={styles.heroSubtitle}>
              The Activity of the association involves developing the Ecosystem of HighTech Legal entities as well as non legal entities like individuals involved in developing highTech products or services, (such as e.g. Software development IT, IoT, hardware development, digital Entrepreneurship etc.)
            </p>
          </div>
          
          <OurServicesSection />
          <ProjectsSection />
        </div>
      </section>
      
      <WhatWeDoSection />
      <PartnerSection />
      <Footer />
    </>
  );
};

export default Home; 